"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Upsell = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _UpsellMixin = require("../../mixins/components/UpsellMixin");
var _Card = require("../Card/Card");
var _CloseButton = require("../CloseButton/CloseButton");
var _MediaObject = require("../MediaObject/MediaObject");
var _TextButton = require("../TextButton/TextButton");
var _excluded = ["direction", "media"];
/**
 * @extends Card
 * @related ['MediaObject']
 * @since 7.8.0
 */
var Upsell = /*#__PURE__*/(0, _styledComponents.default)(function (props) {
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    openState = _useState2[0],
    setOpenState = _useState2[1];
  if (
  // Controlled closed
  typeof props.isOpen === 'boolean' && !props.isOpen ||
  // Uncontrolled closed
  typeof props.isOpen !== 'boolean' && !openState) {
    return null;
  }
  var renderLayout = props.renderLayout;
  var content = renderLayout;
  if (typeof renderLayout === 'function') {
    content = renderLayout(Object.assign({}, props, {
      onClose: function onClose() {
        setOpenState(false);
        if (props.onClose) {
          props.onClose();
        }
      }
    }));
  }

  // Prevent prop bleed to DOM
  var direction = props.direction,
    media = props.media,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Card.Card, rest, content);
}).withConfig({
  displayName: "Upsell",
  componentId: "c11n-8-107-0__sc-1tgvknj-0"
})(["", ""], _UpsellMixin.UpsellMixin);
exports.Upsell = Upsell;
Upsell.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `Button` node used as the primary call to action.
   */
  actionButton: _propTypes.default.node,
  /**
   * Customize the color of the upsell. When using a dark background, the text will be inverted.
   */
  background: _propTypes.default.oneOf(['backgroundWhite', 'backgroundBlue', 'backgroundDarkBlue', 'blue200']),
  /**
   * A `Text` node.
   */
  body: _propTypes.default.node,
  /**
   * By default, an upsell can be closed. Set this to `false` to disallow closing of the upsell.
   */
  closeable: _propTypes.default.bool,
  /**
   * @deprecated Depending on the layout, the close button may appear as an icon or a text button.
   * This will set the value when close is a text button.
   */
  closeText: _propTypes.default.string,
  /**
   * Should always be 'secondary' for Upsells.
   *
   * @ignore
   */
  cardType: _propTypes.default.oneOf(['secondary']),
  /**
   * The direction of the media to be used within the
   * `MediaObject` component.
   */
  direction: _propTypes.default.oneOf(['row', 'column']),
  /**
   * Inherited from `Card`.
   */
  cardElevation: _propTypes.default.oneOf([0, 1]),
  /**
   * A `Heading` node.
   */
  heading: _propTypes.default.node,
  /**
   * A closeable Upsell is uncontrolled by default.
   * You can specify `isOpen` to manually control the visibility of the component.
   */
  isOpen: _propTypes.default.bool,
  /**
   * An `Image` or `Icon` node.
   */
  media: _propTypes.default.node,
  /**
   * Function called when the upsell is closed.
   */
  onClose: _propTypes.default.func
} : {};
Upsell.defaultProps = {
  background: 'backgroundWhite',
  cardType: 'secondary',
  closeable: true,
  direction: 'row',
  cardElevation: 1,
  heading: null,
  isOpen: null,
  media: null,
  renderLayout: function renderLayout(_ref) {
    var actionButton = _ref.actionButton,
      body = _ref.body,
      closeable = _ref.closeable,
      direction = _ref.direction,
      heading = _ref.heading,
      media = _ref.media,
      onClose = _ref.onClose;
    var align = 'start';
    if (direction === 'column') {
      align = 'center';
    }
    var close;
    if (closeable) {
      close = /*#__PURE__*/_react.default.createElement(_CloseButton.CloseButton, {
        onClick: onClose
      });
    }
    var action;
    if (actionButton) {
      action = /*#__PURE__*/_react.default.createElement(_TextButton.TextButton, (0, _extends2.default)({}, actionButton.props, {
        buttonType: "primary"
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_MediaObject.MediaObject, {
      media: media,
      direction: direction,
      align: align
    }, heading, body, action, close);
  }
};

/** @component */